import { IDENTITIES_KEYS_SPECIAL } from '../types';
import { isObject } from './utils';
import { getStorageItem } from './storage';
import { validateValueType } from './identities';
import { getLoginFromWindowObject } from './externals/login';
/**
 * Special "identities" / "identities parts" (rusId, premium, said, ...) can be stored via public api
 * We need to wrap them in to main identity (login) before storing
 */
export const createValueForSpecial = (identificator, value, specials) => {
    // validate
    const valueValidated = validateValueType(identificator, value);
    if (!valueValidated.ok) {
        return null;
    }
    // login -> rusId, premium, said, state
    if (~[
        IDENTITIES_KEYS_SPECIAL.rusId,
        IDENTITIES_KEYS_SPECIAL.said,
        IDENTITIES_KEYS_SPECIAL.premium,
        IDENTITIES_KEYS_SPECIAL.state,
        IDENTITIES_KEYS_SPECIAL.login,
    ].indexOf(identificator)) {
        // "specials" key not existing -> get current storage values
        if (!isObject(specials.login)) {
            specials.login = (getStorageItem('login', {
                rich: false,
                cacheEnough: true,
                justSettled: false,
            }) || {});
        }
        // setting {rusId: "value"} -> sets {uid: "value"}
        if (identificator === IDENTITIES_KEYS_SPECIAL.rusId && !getLoginFromWindowObject()) {
            specials.login.uid = valueValidated.value;
            return 'login';
        }
        // setting {said: "value"} -> sets {advert_uid: "value", said: "value"}
        if (identificator === IDENTITIES_KEYS_SPECIAL.said && !getLoginFromWindowObject()) {
            specials.login.advert_uid = valueValidated.value;
            specials.login.said = valueValidated.value;
            return 'login';
        }
        if (identificator === IDENTITIES_KEYS_SPECIAL.premium && !getLoginFromWindowObject()) {
            specials.login.premium = valueValidated.value;
            return 'login';
        }
        if (identificator === IDENTITIES_KEYS_SPECIAL.state && !getLoginFromWindowObject()) {
            specials.login.state = valueValidated.value;
            return 'login';
        }
        if (identificator === IDENTITIES_KEYS_SPECIAL.login) {
            specials.login = valueValidated.value;
            // setting {login: {rusId: "value"}} -> sets {login: {uid: "value"}}
            if (specials.login.rusId && !specials.login.uid) {
                specials.login.uid = valueValidated.value.rusId;
                delete specials.login.rusId;
            }
            // setting {login: {said: "value"}} -> sets {login: {said: "value", advert_uid: "value"}}
            if (specials.login.said && !specials.login.advert_uid) {
                specials.login.advert_uid = valueValidated.value.said;
            }
            return 'login';
        }
    }
    return null;
};
